/* eslint-disable */
import React, {
  useEffect,
  useState,
  useMemo,
  useContext,
  useCallback,
} from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { getData, postData, putData } from "utils/Gateway";
import * as url from "helper/UrlHelper";

import { MaterialReactTable } from "material-react-table";
import { MenuItem, Box } from "@mui/material";

import { GlobalProvider } from "context/GlobalContext";

import { assetImages } from "constants";

import AccessDeniedView from "components/Common/AccessDeniedView/AccessDeniedView";
import LoadingSkeleton from "components/Common/ListLoadingSkeleton/LoadingSkeleton";
import EventTypeHeader from "./Header/EventTypeHeader";
import SaveEventTypePopup from "./Popup/SaveEventTypePopup";
// import EventTypeFilterPopup from "./Popup/EventTypeFilterPopup";
import AlertNotification from "components/Common/AlertNotification/AlertNotification";

const EventTypeBody = () => {
  const token = localStorage.getItem("token");
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));

  const { t, i18n } = useTranslation();

  const [eventTypeList, setEventTypeList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const [eventTypeId, setEventTypeId] = useState(null);

  const [filterModuleName, setFilterModuleName] = useState("");
  const [filterModuleSlug, setFilterModuleSlug] = useState("");
  const [filterDateRange, setFilterDateRange] = useState("");

  const [jsonFilterQuery, setJsonFilterQuery] = useState([]);
  const [reloadData, setReloadData] = useState(false);
  const [isFilterReset, setIsFilterReset] = useState(false);

  const [rowSelection, setRowSelection] = useState({});
  const [selectedEventTypeIds, setSelectedEventTypeIds] = useState([]);

  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [messageType, setMessageType] = useState("");

  const getAllEventTypes = async () => {
    setRowSelection({});
    setSelectedEventTypeIds([]);

    try {
      setIsLoading(true);
      let requestUrl = `${url.API_BASE_URL}${url.API_GET_ALL_EVENT_TYPES}?token=${token}`;

      const response = await getData(requestUrl);

      console.log("response in event type list------->", response);

      setIsLoading(false);
      if (response.status) {
        setEventTypeList(response.data);
      }
    } catch (error) {
      console.error("Error fetching all event types:", error.message);
    }
  };

  // const getFilteredEventTypes = useCallback(async () => {
  //   try {
  //     setIsLoading(true);
  //     const requestUrl = `${url.API_BASE_URL}${url.API_GET_FILTERED_EVENT_TYPE}?token=${token}`;

  //     const sanitizedQuery = jsonFilterQuery.map((filter) => {
  //       if (
  //         (filter.operator === "includes" || filter.operator === "excludes") &&
  //         Array.isArray(filter.value)
  //       ) {
  //         return {
  //           ...filter,
  //           value: filter.value.map((item) => item.value).join(","),
  //         };
  //       }
  //       return filter;
  //     });

  //     const filterData = {
  //       filters: sanitizedQuery,
  //     };

  //     const response = await postData(requestUrl, filterData);

  //     setIsLoading(false);

  //     if (response.status) {
  //       setEventTypeList(response.data);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching filtered event types:", error.message);
  //   }
  // }, [token, jsonFilterQuery]);

  const deleteBulkHandler = async () => {
    if (selectedEventTypeIds.length > 0) {
      try {
        const eventTypeListToBeDelete = eventTypeList.filter((item) =>
          selectedEventTypeIds.includes(item._id)
        );

        let apiData = {
          eventtypelist: eventTypeListToBeDelete,
        };

        let requestURL =
          url.API_BASE_URL + url.API_DELETE_BULK_EVENT_TYPE + `?token=${token}`;

        const response = await putData(requestURL, apiData);

        console.log(response);

        if (response.status) {
          setMessageType("success");
          setAlertMessage("Event type deleted successfully");

          setTimeout(() => {
            setEventTypeList((prevList) =>
              prevList.filter(
                (item) => !selectedEventTypeIds.includes(item._id)
              )
            );
          }, 1500);
        } else {
          setMessageType("error");
          setAlertMessage(response.message);
        }
      } catch (error) {
        setAlertMessage(error.message);
        setMessageType("error");
      }
    } else {
      setAlertMessage("Please select at least one event type");
      setMessageType("error");
    }
    setShowAlert(true);
  };

  const afterSaveEventType = (data = {}) => {
    setEventTypeList((prevList) => {
      const index = prevList.findIndex((item) => item._id === data._id);

      if (index !== -1) {
        // replace (update)
        const newList = [...prevList];
        newList[index] = data;
        return newList;
      } else {
        // unshift (add at beginning)
        return [data, ...prevList];
      }
    });
  };

  const resetFilterData = () => {
    setJsonFilterQuery([]);
    setIsFilterReset(true);
    setReloadData(true);
  };

  const columns = useMemo(
    () => [
      {
        accessorKey: "#",
        header: t("Actions"),
        size: 70,
        Cell: ({ row }) => (
          <button
            className="action_btn_mui"
            data-bs-toggle="offcanvas"
            data-bs-target="#saveEventType"
            aria-controls="saveEventType"
            onClick={() => {
              setEventTypeId(row.original._id);
            }}
          >
            <span className="d-block material-symbols-outlined horz_icon">
              more_horiz
            </span>
          </button>
        ),
        enableColumnActions: false,
        enableColumnDragging: false,
        enableSorting: false,
      },
      {
        accessorKey: "label",
        header: t("Name"),
        size: 400,
      },
      {
        accessorKey: "slug",
        header: t("Slug"),
        size: 400,
      },
      {
        accessorKey: "createddate",
        header: t("Date"),
        size: 300,
      },
    ],
    [i18n.language, eventTypeList]
  );

  const initialColumnOrder = [
    "#",
    "mrt-row-select",
    ...columns.map((c) => c.accessorKey),
  ];

  useEffect(() => {
    getAllEventTypes();
  }, []);

  useEffect(() => {
    if (reloadData) {
      getAllEventTypes();
      setReloadData(false);
    }
  }, [reloadData]);

  useEffect(() => {
    const selectedIdsArray = Object.keys(rowSelection).filter(
      (key) => rowSelection[key]
    );

    setSelectedEventTypeIds(selectedIdsArray);
  }, [rowSelection]);

  const onAlertClose = () => {
    setShowAlert(false);
    setAlertMessage("");
    setMessageType("");
  };

  if (userInfo.role.slug === "ADMIN" || userInfo.role.slug === "SUPER_ADMIN") {
    return (
      <div id="content_wrapper" className="eventtype-body-wrapper">
        <section className="crm-wrapper bg-white pb-5 rounded-3 shadow-sm">
          <div className="container-fluid px-lg-5 py-4">
            <EventTypeHeader
              reloadList={resetFilterData}
              changeStatusHandler={deleteBulkHandler}
            />

            {isLoading ? (
              <LoadingSkeleton />
            ) : (
              <div className="table-wrapper">
                <MaterialReactTable
                  columns={columns}
                  data={eventTypeList}
                  enableGrouping
                  enableRowSelection
                  getRowId={(row) => row._id}
                  onRowSelectionChange={setRowSelection}
                  state={{ rowSelection, columnOrder: initialColumnOrder }}
                  initialState={{
                    rowSelection,
                    columnOrder: initialColumnOrder,
                  }}
                  defaultColumn={{
                    minSize: 20,
                    maxSize: 300,
                    size: 50,
                  }}
                  muiTableContainerProps={{
                    sx: {
                      maxHeight: "60vh",
                    },
                  }}
                  enableStickyHeader
                  enableColumnResizing
                  enableColumnActions
                  enableColumnFilters
                  enablePagination
                  enableSorting
                  enableBottomToolbar
                  enableTopToolbar
                />
              </div>
            )}
          </div>
        </section>

        <SaveEventTypePopup
          afterPopupCLose={afterSaveEventType}
          eventTypeId={eventTypeId}
          setEventTypeId={setEventTypeId}
        />

        {/* <EventTypeFilterPopup
          setJsonFilterQuery={setJsonFilterQuery}
          reloadList={resetFilterData}
          moduleSlug="eventtypelist"
          isFilterReset={isFilterReset}
          setIsFilterReset={setIsFilterReset}
        /> */}

        {showAlert && (
          <AlertNotification
            showAlert={showAlert}
            message={alertMessage}
            alertType={messageType}
            onClose={onAlertClose}
          />
        )}
      </div>
    );
  } else {
    return <AccessDeniedView />;
  }
};

export default EventTypeBody;
